<template>
    <section>
        <div v-if="linkTo.length == 0 || linkTo[0] == ''">
            <h1>Before sending some commands link yourself with a gps</h1>
        </div>
        <div v-else class="linkTo">
            <button @click="freeAll"> Free All Clients </button>
            <br>
            <p v-for="client in linkTo" :key="client">
              <strong>
                {{ client }} 
              </strong>
              <button @click="freeClient(client)">
                Free Client
              </button>
            </p>
            <label for="command">Command</label>
            <input type="text" name="command" id="command" v-model="command">
            <button @click="getCommandSent">Sent Command</button>
            <br>
            <input type="file" name="file" id="file" v-on:change="setFile">
            <br>
            <button @click="sendFile">Sent File</button>
            <ClientResponse></ClientResponse>
        </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ClientResponse from "./ClientResponse.vue";
export default {
  name: "linkTo",
  data() {
    return {
      command: null,
      fileString: null
    };
  },
  computed: {
    ...mapState(["linkTo", "admin", "listClients"])
  },
  methods: {
    ...mapMutations(["updateLinkTo"]),
    getCommandSent() {
      this.$socket.emit("reqCommandSent", {
        command: this.command,
        admin: this.admin
      });
    },
    freeClient(client) {
      this.$socket.emit("reqFreeClient", {
        client: client,
        admin: this.admin
      });
    },
    setFile(e){
      this.fileToString(e.target.files[0])
    },
    fileToString(file){
      let _this = this;
      if(!window.FileReader) return; // Browser is not compatible
      var reader = new FileReader();
      reader.onload = function(evt) {
          if(evt.target.readyState != 2) return;
          if(evt.target.error) {
              alert('Error while reading file');
              return;
          }
          _this.fileString = evt.target.result;
      };
      reader.readAsText(file);
    },
    sendFile(){
      if (this.fileString != null) {
        let api = 'https://telemetrianode.hmhsistemas.com.mx:7069'
        let data = {comandos: this.fileString, clients: JSON.stringify(this.linkTo)}
        let headers ={
          headers: {
              'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InJvbElkIjo5LCJ1c2VybmFtZSI6Imlub3ZlbGEiLCJ1c3VhcmlvSWQiOjMxLCJpZFVzdWFyaW8iOjMwLCJjbGllbnRlU29ja2V0Ijp0cnVlLCJ3aGl0ZUxpc3QiOlsiNDQ2MiIsIjQ0NjAiLCI0NDU5IiwiNDQ2MyIsIjQ0NjYiXX0sImlhdCI6MTU3MDA0ODMxNSwiZXhwIjoxNTc3MjQ4MzE1fQ.eV0m4FFPjPfaM4Qtip9YtoRoQDJAhXALtDkpXH1pB0k'
          }
        }
        this.axios.post(`${api}/geocercas`, data, headers).then((response) => {
          console.log(response.data)
        })
        .catch((err) => {
          console.log(err)
        })
      }
    },
    freeAll() {
      this.linkTo.map((client) => {
        this.freeClient(client)
      })
    }
  },
  sockets: {
    resLinkTo(data) {
      this.updateLinkTo(data);
    }
  },
  components: {
    ClientResponse
  }
};
</script>